import { render, staticRenderFns } from "./TarpStatus.vue?vue&type=template&id=1ec80a08&scoped=true&"
import script from "./TarpStatus.vue?vue&type=script&lang=ts&"
export * from "./TarpStatus.vue?vue&type=script&lang=ts&"
import style0 from "./TarpStatus.vue?vue&type=style&index=0&id=1ec80a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec80a08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
